import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { getItemDetails } from './PharmacyMedicineService';
import { Breadcrumbs, H5 } from '../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import { ArrowLeft } from 'react-feather';
import { useLoader } from '../../_helper/LoaderContext';
import { usePharmacy } from '../../_helper/PharmacyProvider';

const ViewMedicine = () => {
	const { mdcId } = useParams();
	const { t } = useTranslation();
	const history = useNavigate();
	const { setLoading } = useLoader();
	const { pharmacyPOS } = usePharmacy();
	const [medicineDetails, setMedicineDetails] = useState(null);

	// ✅ Fetch item details on load
	useEffect(() => {
		const fetchItem = async () => {
			try {
				setLoading(true);
				const body = {
					itemId: mdcId,
					clinicId: pharmacyPOS?.hospital_id,
				}

				const res = await getItemDetails(body);

				// ✅ Access the nested item
				if (res?.data?.data) {
					const item = res.data.data;
					setMedicineDetails(item);
				}
			} catch (error) {
				console.error("Error fetching item:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchItem();
	}, [mdcId]);

	const gotoList = () => {
		history(`${process.env.PUBLIC_URL}/items`);
	}

	// ✅ Simple field renderer
	const renderField = (label, value) => (
		<div className="mb-3">
			<strong>{t(label)}: </strong> {value || "-"}
		</div>
	);

	return (
		<Fragment>
			<Breadcrumbs mainTitle={t('Item Details')} parent={t('Dashboard')} title={t('Item Details')} />
			<Col sm="12">
				<Card>
					<CardHeader className="d-flex justify-content-end align-items-center">
						{/* <H5>{t('Medicine Details')}</H5> */}
						<button
							className="btn btn-primary d-flex align-items-center"
							style={{ color: 'white', height: "40px" }}
							to=""
							onClick={gotoList}>
							<ArrowLeft className="me-2" /> {t("Back")}
						</button>
					</CardHeader>
					{/* <CardBody>
						{medicineDetails ? (
							<Row>
								<Col md="6">
									{renderField("Code", medicineDetails.code)}
									{renderField("Product Name", medicineDetails.brandName)}
									{renderField("Salt Name / Composition", medicineDetails.saltName)}
									{renderField("Manufacturer", medicineDetails.manufacturer)}
									{renderField("Form", medicineDetails.productForm)}
									{renderField("Package", medicineDetails.package)}
									{renderField("Quantity", medicineDetails.quantity)}
									{renderField("Currency", medicineDetails.currency)}
								</Col>
								<Col md="6">
									{renderField("Regular Price", medicineDetails.regularPrice)}
									{renderField("Discount (%)", medicineDetails.discount)}
									{renderField("Tax", `${medicineDetails.tax}% (${medicineDetails.taxType})`)}
									{renderField("Selling Price", medicineDetails.salePrice)}
									{renderField("Min Qty Alert", medicineDetails.minQuantityAlert)}
									{renderField("Max Qty Alert", medicineDetails.maxQuantityAlert)}
									{renderField("Note", medicineDetails.note)}
								</Col>
							</Row>
						) : (
							<p>{t("Loading medicine details...")}</p>
						)}
					</CardBody> */}
					<CardBody>
						{/* {medicineDetails ? ( */}
						<div className="table-responsive rounded">
							<Table className="table-center table-bordered mb-0 table-hover">
								<tbody>
									<tr>
										<th><strong>{t("Code")}</strong></th>
										<td>{medicineDetails?.code}</td>
									</tr>
									<tr>
										<th><strong>{t("Bar Code")}</strong></th>
										<td>{medicineDetails?.barcode}</td>
									</tr>
									<tr>
										<th><strong>{t("Brand Name")}</strong></th>
										<td>{medicineDetails?.brandName}</td>
									</tr>
									<tr>
										<th><strong>{t("Salt Name / Composition")}</strong></th>
										<td>{medicineDetails?.saltName}</td>
									</tr>
									<tr>
										<th><strong>{t("Manufacturer")}</strong></th>
										<td>{medicineDetails?.manufacturer}</td>
									</tr>
									<tr>
										<th><strong>{t("Product Form")}</strong></th>
										<td>{medicineDetails?.productForm}</td>
									</tr>
									<tr>
										<th><strong>{t("Package")}</strong></th>
										<td>{medicineDetails?.package}</td>
									</tr>
									<tr>
										<th><strong>{t("Product Quantity")}</strong></th>
										<td>{medicineDetails?.packageQuantity}</td>
									</tr>
									<tr>
										<th><strong>{t("MRP")}</strong></th>
										<td>{medicineDetails?.regularPrice} {medicineDetails?.currency}</td>
									</tr>
									<tr>
										<th><strong>{t("Tax")}</strong></th>
										{medicineDetails?.tax ? <td>{medicineDetails?.tax}%</td> : <td>-</td>}
									</tr>
									{/* <tr>
										<th><strong>{t("Discount")}</strong></th>
										<td>{medicineDetails?.discount}%</td>
									</tr>
									<tr>
										<th><strong>{t("Sale Price")}</strong></th>
										<td>{Math.floor(medicineDetails?.salePrice)} {medicineDetails?.currency}</td>
									</tr>
									<tr>
										<th><strong>{t("Tax")}</strong></th>
										<td>{medicineDetails?.tax}% ({medicineDetails?.taxType})</td>
									</tr> */}
									{/* <tr>
										<th><strong>{t("Stock Quantity")}</strong></th>
										<td>{medicineDetails?.stockQuantity}</td>
									</tr> */}
									{/* <tr>
										<th><strong>{t("Stock Unit Price")}</strong></th>
										<td>{medicineDetails?.stockUnitPrice} {medicineDetails?.currency}</td>
									</tr>
									<tr>
										<th><strong>{t("Average Purchase Price")}</strong></th>
										<td>{medicineDetails?.avgPurchasePrice} {medicineDetails?.currency}</td>
									</tr> */}
									<tr>
										<th><strong>{t("Min Quantity Alert")}</strong></th>
										<td>{medicineDetails?.minQuantityAlert}</td>
									</tr>
									{/* <tr>
										<th><strong>{t("Max Quantity Alert")}</strong></th>
										<td>{medicineDetails?.maxQuantityAlert}</td>
									</tr> */}
									{/* <tr>
										<th><strong>{t("Return Quantity")}</strong></th>
										<td>{medicineDetails?.returnQuantity}</td>
									</tr>
									<tr>
										<th><strong>{t("Return Price")}</strong></th>
										<td>{medicineDetails?.returnPrice} {medicineDetails?.currency}</td>
									</tr> */}

									<tr>
										<th><strong>{t("Note")}</strong></th>
										<td>{medicineDetails?.note !== "" ? medicineDetails?.note : "-"}</td>
									</tr>
								</tbody>
							</Table>
						</div>
						{/* ) : (
						<p>{t("Loading medicine details...")}</p>
						 )} */}
					</CardBody>
				</Card>
			</Col>
		</Fragment>
	)
}

export default ViewMedicine